if (typeof window.DD_RUM == 'undefined' || !window.DD_RUM) {
    window.ur = window.ur || {};
    window.ur.isResizeObserverLoopMsg = function (msg) {
        return /ResizeObserver loop (?:limit exceeded|completed with undelivered notifications)/i
            .test(msg || '');
    };

    (function (h, o, u, n, d) {
        h = h[d] = h[d] || { q: [], onReady: function (c) { h.q.push(c) } }
        d = o.createElement(u); d.async = 1; d.src = n
        n = o.getElementsByTagName(u)[0]; n.parentNode.insertBefore(d, n)
    })(window, document, 'script', 'https://www.datadoghq-browser-agent.com/eu1/v6/datadog-rum.js', 'DD_RUM')
    window.DD_RUM.onReady(function () {
        window.DD_RUM.init({
            clientToken: 'pubd48c0f05ed41ae2254516eaa47b1620b',
            applicationId: '99fc97d9-9f19-41f5-8988-34e81ca4a6bc',
            site: 'datadoghq.eu',
            service: 'www.universal-robots.com',
            env: window.ur.envName ?? 'unknown',
            // Specify a version number to identify the deployed version of your application in Datadog
            // version: '1.0.0',
            sessionSampleRate: 100,
            sessionReplaySampleRate: 5,
            defaultPrivacyLevel: 'mask-user-input',
            trackingConsent: 'not-granted',

            beforeSend: function (event) {
                if (event.type === 'error') {
                    const message = event.error?.message || '';
                    if (window.ur.isResizeObserverLoopMsg(message)) {
                        console.debug('Dropping ResizeObserver loop error from RUM');
                        return false; // Drop the event
                    }
                }
                return true
            }
        });
    });

    window.addEventListener(
        'CookiebotOnConsentReady',
        function () {
            if (!Cookiebot.consent.statistics) return;

            window.DD_RUM.onReady(function() {
                window.DD_RUM.setTrackingConsent('granted');
            });
        },
        false
    );
}
